<h2 mat-dialog-title>{{ title }}</h2>
<!-- <p class="subtitle">{{ data.subTitle }}</p> -->
<mat-dialog-content>
  @if (step === 1) {
    <form [formGroup]="form">
      <app-input-field
        label="Type"
        placeholder="Select website type"
        type="select"
        [options]="types"
        formControlName="type"
        hint="Site, Main, Alias or Subdomain"
      ></app-input-field>

      @for (control of controlsArray; track control.label) {
        @if (control.type !== 'checkbox') {
          @switch (control.controlName) {
            @case ('originServer') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="servers()"
                [formControlName]="control.controlName"
                [(searchText)]="serverSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('websiteId') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="(websites$ | async) || []"
                [formControlName]="control.controlName"
                [(searchText)]="websiteSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('groupId') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="(groupsOptions$ | async) || []"
                [formControlName]="control.controlName"
                [(searchText)]="groupSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('domain') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [formControlName]="control.controlName"
                [suffixText]="(websiteSuffixText$ | async) || ''"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('plan') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="plans || []"
                [formControlName]="control.controlName"
                [(searchText)]="ownerSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @case ('userId') {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="(ownerOptions$ | async) || []"
                [formControlName]="control.controlName"
                [(searchText)]="ownerSearchText"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
            @default {
              <app-input-field
                [label]="control.label"
                [placeholder]="control.placeholder || ''"
                [type]="control.type"
                [options]="control.options || []"
                [formControlName]="control.controlName"
                [errorMessages]="control.errors"
              ></app-input-field>
            }
          }
        }
      }

      <div class="checkboxes">
        @for (control of controlsArray; track control.label) {
          @if (control.type === 'checkbox') {
            <mat-checkbox [formControlName]="control.controlName">{{ control.label }}</mat-checkbox>
          }
        }
      </div>
    </form>
  } @else {
    <form [formGroup]="wordpressForm">
      <app-input-field
        label="WP Admin Username"
        formControlName="user"
        [errorMessages]="wpErrors['user']"
      ></app-input-field>

      <app-input-field
        label="WP Admin Password "
        type="password"
        autocomplete="new-password"
        formControlName="password"
        [errorMessages]="wpErrors['password']"
      ></app-input-field>

      <!-- <app-input-field
        label="Install in directory"
        hint="To install WordPress in Subdirectory, type it above "
        formControlName="directory"
      ></app-input-field> -->

      <app-input-field
        label="Email"
        formControlName="email"
        [errorMessages]="wpErrors['email']"
      ></app-input-field>

      <div class="checkboxes">
        <mat-checkbox formControlName="enableRedisCache">Enable Redis Cache</mat-checkbox>
        <mat-checkbox formControlName="enableW3TotalCache">Install W3 Total Cache</mat-checkbox>
        <mat-checkbox formControlName="enableWooCommerce">Install WooCommerce</mat-checkbox>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button
    matButton="filled"
    (click)="submit()"
    [disabled]="form.invalid || (step === 2 && wordpressForm.invalid)"
  >
    {{ primaryButtonText }}
  </button>
  <button matButton="tonal" (click)="close()">Close</button>
</mat-dialog-actions>
